import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { type ReactElement, useEffect } from 'react'
import type { MeetingLocationType } from '~/api/mutations/action'
import type { InputInFormProps } from '~/components/Form/Input/input'
import { Label } from '~/components/Form/Input/Label'
import {
  errorMessage,
  inputWrapper
} from '~/components/Form/Input/TextInput.css'
import {
  Button,
  ButtonVariation
} from '~/components/Global/Interactions/Button'
import { locationChoices } from './MeetingLocationTypeInput.css'

export type MeetingLocationTypeOption = {
  label: string
  value: MeetingLocationType
  icon: IconDefinition
}

type MeetingLocationTypeInputProps = InputInFormProps & {
  name: string
  label: string
  options: MeetingLocationTypeOption[]
  value: MeetingLocationType | null
  onChange: (value: MeetingLocationType) => void
}

export const MeetingLocationTypeInput = ({
  name,
  label,
  options,
  value,
  onChange,
  register,
  setValue,
  error
}: MeetingLocationTypeInputProps): ReactElement => {
  useEffect(() => {
    register?.(name)
  }, [register, name])

  useEffect(() => {
    setValue?.(name, value ?? undefined, {
      shouldDirty: false,
      shouldValidate: value !== null
    })
  }, [setValue, name, value])

  return (
    <div className={inputWrapper}>
      <Label>{label}</Label>
      <div className={locationChoices} role="radiogroup" aria-label={label}>
        {options.map((option) => (
          <Button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={option.value === value}
            variation={
              option.value === value
                ? ButtonVariation.Primary
                : ButtonVariation.Neutral
            }
            buttonSize="small"
            onClick={() => onChange(option.value)}
          >
            <FontAwesomeIcon icon={option.icon} />
            {option.label}
          </Button>
        ))}
      </div>
      {error !== undefined && (
        <div className={errorMessage} role="alert">
          {error.message}
        </div>
      )}
    </div>
  )
}
